import * as React from "react";
import { Grid, Box, List, ListItem, ListItemText } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useContext, useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation, useNavigate } from "react-router-dom";
import { PreferencesContext } from "../../PreferenceContext";
import { GetFinancialYearList } from "../../services/MasterService";
import { AlertType } from "../../services/models/AlertType";

export default function FinancialYearList(props: any) {
  let navigate = useNavigate();
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [finencialYearData, setFinencialYearResultData] = useState([]);

  const { userContext, updateUserContext } = useContext(PreferencesContext);

  const handleListItemFinancialYearClick = (item: any) => {
    props.onselect();
    if (pathname === "/dashboard") {
      navigate(0);
    } else {
      navigate("/dashboard");
    }
    const context = userContext;
    context.financialYearDetail.financialYear = item.financialYear;
    context.financialYearDetail.financialYearStartDate =
      item?.financialYearStartDate || null;
    context.financialYearDetail.financialYearEndDate =
      item?.financialYearEndDate || null;
    updateUserContext({
      ...context,
      isAlert: true,
      alertMessage: "Financial year changed to " + item.financialYear + "",
      alertType: AlertType.Success,
    });
  };

  const fetchFinancialYearList = async () => {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId?.toString());
      params.append("organizationId", userContext.organizationId?.toString());
      params.append("branchId", userContext.branchId?.toString());
      const result: any = await GetFinancialYearList(params);
      if (result?.data?.data) {
        let FinancialYearInfo = result.data.data;
        setFinencialYearResultData(FinancialYearInfo);
      }
    } catch (e) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  const fetchData = async () => {
    try {
      await fetchFinancialYearList();
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData();
  }, []);

  return (
    <>
      <React.Fragment>
        <Grid>
          <Box>
            <List>
              {finencialYearData.map((item: any, index) => {
                return (
                  <ListItem
                    className={
                      userContext?.financialYearDetail?.financialYear ===
                      item.financialYear
                        ? "financial-year-list-data border-primary"
                        : "financial-year-list-data"
                    }
                    disablePadding
                    onClick={() => {
                      if (!isLoading) {
                        handleListItemFinancialYearClick(item);
                      }
                    }}
                    key={index}
                  >
                    <span className="">
                      <TrendingUpIcon className="primary-color" />
                    </span>
                    <span>
                      <ListItemText
                        primary={
                          <span className="bold-600">{item.financialYear}</span>
                        }
                      />
                    </span>
                  </ListItem>
                );
              })}
            </List>
          </Box>
        </Grid>
      </React.Fragment>
    </>
  );
}
